import React from 'react'
import { bool, func } from 'prop-types'
import styled from 'styled-components'

import { Link } from 'gatsby'
import Modal, { ModalSection } from 'components/Modal'

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const MissingAddressModal = ({ visible, setMissingAddressModalVisibility, close }) => {
  return (
    <Modal
      visible={visible}
      close={() => {
        close()
      }}
    >
      <ModalSection>
        <Inner>
          <p>
            {`We need to know your province before you can checkout, please complete your address in ${' '}`}
            <Link
              to="/account/"
              onClick={() => {
                setMissingAddressModalVisibility(false)
              }}
            >
              My Account
            </Link>
            .
          </p>
        </Inner>
      </ModalSection>
    </Modal>
  )
}

MissingAddressModal.propTypes = {
  visible: bool.isRequired,
  setMissingAddressModalVisibility: func.isRequired,
  close: func.isRequired
}

export default MissingAddressModal
